const dominicanRepublic = [
    { "code": "Distrito Nacional", "name": "Distrito Nacional" },
    { "code": "Azua", "name": "Azua" },
    { "code": "Baoruco", "name": "Baoruco" },
    { "code": "Barahona", "name": "Barahona" },
    { "code": "Dajabón", "name": "Dajabón" },
    { "code": "Duarte", "name": "Duarte" },
    { "code": "Elías Piña", "name": "Elías Piña" },
    { "code": "El Seibo", "name": "El Seibo" },
    { "code": "Espaillat", "name": "Espaillat" },
    { "code": "Hato Mayor", "name": "Hato Mayor" },
    { "code": "Hermanas Mirabal", "name": "Hermanas Mirabal" },
    { "code": "Independencia", "name": "Independencia" },
    { "code": "La Altagracia", "name": "La Altagracia" },
    { "code": "La Romana", "name": "La Romana" },
    { "code": "La Vega", "name": "La Vega" },
    { "code": "María Trinidad Sánchez", "name": "María Trinidad Sánchez" },
    { "code": "Monseñor Nouel", "name": "Monseñor Nouel" },
    { "code": "Monte Cristi", "name": "Monte Cristi" },
    { "code": "Monte Plata", "name": "Monte Plata" },
    { "code": "Pedernales", "name": "Pedernales" },
    { "code": "Peravia", "name": "Peravia" },
    { "code": "Puerto Plata", "name": "Puerto Plata" },
    { "code": "Samaná", "name": "Samaná" },
    { "code": "San Cristóbal", "name": "San Cristóbal" },
    { "code": "San José de Ocoa", "name": "San José de Ocoa" },
    { "code": "San Juan", "name": "San Juan" },
    { "code": "San Pedro de Macorís", "name": "San Pedro de Macorís" },
    { "code": "Sánchez Ramírez", "name": "Sánchez Ramírez" },
    { "code": "Santiago", "name": "Santiago" },
    { "code": "Santiago Rodríguez", "name": "Santiago Rodríguez" },
    { "code": "Santo Domingo", "name": "Santo Domingo" },
    { "code": "Valverde", "name": "Valverde" }
  ]
export default dominicanRepublic;